import { client } from '@api/client';

export async function getNote(userId: string) {
    return client.GET(`/user-note/{userId}`, {
        params: {
            path: {
                userId,
            },
        },
    });
}

export async function saveNote(userId: string, noteText: string): Promise<{ ok: boolean}> {
    const response = await client.POST('/user-note/save/{userId}', {
        params: {
            path: {
                userId,
            },
        },
        body: {
            text: noteText,
        },
    });
    return {
        ok: response.response.ok,
    };
}
